import e from"react";import r from"prop-types";function n(r){var n=r.children;return e.createElement("div",{className:"epn-container"},n)}n.displayName="Container",n.propTypes={children:r.node.isRequired};export{n as default};
